// extracted by mini-css-extract-plugin
module.exports = {"shareLinks":"ShareButtons_shareLinks__b_81K","shareLinksItem":"ShareButtons_shareLinksItem__9sh5y","shareLinksIcon":"ShareButtons_shareLinksIcon__vMBAX"};